<k-area-blocker [showLoader]="_isBusy" [message]="_blockerMessage">
  <div class="kEditWin kOverrideFAIcons" #captionsEdit>
    <form [formGroup]="transcodingProfileSelectForm" novalidate>
      <div class="kHeader">
        <span class="kTitle">{{ _title }}</span>
      </div>

      <div class="kContainer">
        <div class="kRow">
          <span class="kLabel">{{
            'applications.upload.transcodingProfilesSelect.selectTranscodingProfile' | translate
          }}</span>
          <p-dropdown [options]="_profiles" formControlName="profile"></p-dropdown>
        </div>
      </div>

      <div class="kFooter">
        <button
          type="button"
          class="kButtonBranded"
          (click)="_saveAndClose()"
          pButton
          label="{{ 'applications.upload.transcodingProfilesSelect.apply' | translate }}"
        ></button>
      </div>
    </form>
  </div>
</k-area-blocker>
